export enum OrderTypes {
  Asc = 'asc',
  Desc = 'desc',
}
